import type { Ref } from '@vue/composition-api';
import { computed } from '@vue/composition-api';
import { CommentsHelper } from '../helpers/comments.helper';
import type { Comment } from '../types/comment';
import { CommentStatus } from '../types/comment-status';
import type { CurrentUser } from '../types/current-user';

export function useCommentMetadata(
  comment: Ref<Comment>,
  currentUser: Ref<CurrentUser>,
  readOnly: Ref<boolean>,
  isSelected: Ref<boolean>
) {
  const isDraft = computed(() => CommentsHelper.isDraft(comment.value));
  const isResolved = computed(() => comment.value.status === CommentStatus.Resolved);
  const isGhost = computed(() => CommentsHelper.isGhostComment(comment.value));

  const isResolvable = computed(
    () =>
      comment.value.status === CommentStatus.Active && isCurrentUserCreator.value && !readOnly.value
  );

  const isCurrentUserCreator = computed(() => {
    const creatorId = comment.value.createdBy.recipientId || comment.value.createdBy.userId;
    const currentUserId = currentUser.value.recipientId || currentUser.value.userId;
    return creatorId === currentUserId;
  });

  const richTextValue = computed(() => {
    if (isDraft.value) {
      return comment.value.richText || '';
    }
    return '';
  });

  const visibleReplies = computed(() =>
    isSelected.value ? comment.value.replies : comment.value.replies.slice(0, 2)
  );

  return {
    isDraft,
    isResolved,
    isGhost,
    isResolvable,
    isCurrentUserCreator,
    richTextValue,
    visibleReplies,
  };
}
